import { useObservable } from '@hooks/useObservable';

import { contractStore } from '../contractStore';

export const useResidents = () =>
  useObservable(() => ({
    residents: contractStore.residents,
    nonContractPartyResidents: contractStore.nonContractPartyResidents,
    contractPartyResidents: contractStore.contractPartyResidents,
    isNonContractParty: contractStore.isUserNonContractParty,
    isFetching: contractStore.isFetching,
  }));
